import React, { useEffect, useState } from "react";
import {
  CircularProgress,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow
} from '@material-ui/core';
import { FormattedMessage, useIntl } from 'react-intl';
import jzip from 'xlsx/dist/jszip';
import 'xlsx/dist/xlsx.full.min.js';
import { StyledTableCellProps as StyledTableCell, StyledTooltip } from '../../commons/utils/TableStyles';
import ConfigPeriodosPresupuestariosGridRow from './ConfigPeriodosPresupuestariosGridRow.jsx';
import * as Utils from '../../commons/utils/Utils';
import { Redirect } from 'react-router-dom'
import Security from '../../commons/security/Security.js';



window.JSZip = jzip;

const ConfigPeriodosPresupuestariosGrid = (props) => {
  const intl = useIntl()
  const [loading, setLoading] = useState(false)
  const [redirectTo, setRedirectTo] = useState(null)
  const [configs, setConfigs] = useState([]);
  const [verBotoncrearConfigs, setVerBotonCrearConfigs] = useState(false);


  useEffect(() => {
    setLoading(true)
    if (Security.hasPermission("PERIODO_PRESUPUESTARIO_CONFIG_CONFIGURAR")) {
     init() } else {
      setRedirectTo("/error")
    }
    return () => { }
  }, [])

  const init = () => {
    Utils.getData(`/periodo-configs`).then((data) => {
      if (data.periodosConfig.length < 1) {
          setVerBotonCrearConfigs(true);
        } else {
          setVerBotonCrearConfigs(false);
        }
        setConfigs(data.periodosConfig)
        setLoading(false);
    }).catch((error) => {
        console.log(error);
        setLoading(false);
    })
  };



  return (
    <>
     {redirectTo && <Redirect push to={redirectTo} />}
      <div className="card">
        <div className="card-content collpase show">
          <div className="card-body card-dashboard">
          {verBotoncrearConfigs && (
            <div className="container-fluid mb-1">
              <div className="row dt-icons" style={{ width: '100%' }}>
                <div className="col">
                <StyledTooltip
                title={intl.formatMessage({
                  id: 'configPeriodosPresupuestarios.button.label_add',
                  defaultMessage: 'Crear Configuración de Período',
                })}
                arrow
                placement="right"
              >
                <div
                  className="btn btn-primary box-shadow-2 btn-round btn-lg btn-dt-main round-icon"
                  style={{ height: 55 }}
                  onClick={() => setRedirectTo(props.match.url + '/add')}
                >
                  <i className="ft-plus"></i>
                </div>
              </StyledTooltip>
                </div>
              </div>
            </div>)}
            <TableContainer>
              <Table aria-label="clases table" className="table-hover">
                <TableHead>
                  <TableRow>
                    <StyledTableCell align="left">
                      <FormattedMessage id="configPeriodosPresupuestariosGrid.rennder.column_nombre.label" defaultMessage="Nombre" />
                    </StyledTableCell>
                    <StyledTableCell align="left" >
                      <FormattedMessage id="configPeriodosPresupuestariosGrid.rennder.column_frecuencia.label" defaultMessage="Frecuencia" />
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <FormattedMessage id="configPeriodosPresupuestariosGrid.rennder.column_duracion.label" defaultMessage="Duración" />
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <FormattedMessage id="configPeriodosPresupuestariosGrid.rennder.column_fechaInicio.label" defaultMessage="Fecha Inicio" />
                    </StyledTableCell>
                    <StyledTableCell align="center" style={{ width: "150px" }}>
                      <FormattedMessage id="configPeriodosPresupuestariosGrid.rennder.column_acciones.label" defaultMessage="Acciones" />
                    </StyledTableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {loading && (
                    <TableRow>
                      <StyledTableCell colSpan={14} align="center">
                        <CircularProgress />
                      </StyledTableCell>
                    </TableRow>
                  )}
                  {!loading &&
                    (configs.length > 0 ?
                      configs.map((config) => (
                        <ConfigPeriodosPresupuestariosGridRow
                          key={'configPeriodosPresupuestariosGridRow_' + config.id}
                          config={config}
                          loading={loading}
                          baseUrl = {props.match.url} 
                        />
                      ))
                      :
                      <TableRow>
                        <StyledTableCell colSpan={14} align="center">
                          <FormattedMessage id="configPeriodosPresupuestariosGrid.rennder.no_data_table" defaultMessage="No se encontraron resultados..." />
                        </StyledTableCell>
                      </TableRow>
                    )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </div>
      </div>
    </>
  )
}


export default ConfigPeriodosPresupuestariosGrid